import { render, staticRenderFns } from "./StoresInformation.vue?vue&type=template&id=31004c0b&scoped=true&"
import script from "./StoresInformation.vue?vue&type=script&lang=js&"
export * from "./StoresInformation.vue?vue&type=script&lang=js&"
import style0 from "./StoresInformation.vue?vue&type=style&index=0&id=31004c0b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31004c0b",
  null
  
)

export default component.exports